<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h5 class="modal-title" id="standard-modalLabel">{{ 'shared.settingsWebhookForm.title' | translate }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" class="w-100 col-lg-8">
        <div class="row">
          <div class="custom-switch mb-2">
            <input type="checkbox" id="activeCheckbox" data-switch="success" formControlName="actived" />
            <label for="activeCheckbox">
              <span class="d-block fw-bold">
                {{ formGroup.get('actived').value ? ('shared.settingsWebhookForm.webhookEnabled' | translate) : ('shared.settingsWebhookForm.webhookDisabled' | translate) }}
              </span>
            </label>
          </div>
          <div class="col-12 mb-2">
            <label for="name" class="form-label">{{ 'shared.settingsWebhookForm.nameLabel' | translate }} <span class="text-info" style="cursor: pointer"
                (click)="toggleNameTooltip()" [title]="'shared.settingsWebhookForm.nameInfoTitle' | translate">
                <i class="fas fa-question-circle"></i>
              </span></label>
            <input id="name" formControlName="name" class="form-control" [placeholder]="'shared.settingsWebhookForm.namePlaceholder' | translate"
              [ngClass]="{ 'is-invalid': formGroup.get('name').invalid && formGroup.get('name').touched }" />
            @if (showNameTooltip) {
            <div class="text-muted small mt-1">
              {{ 'shared.settingsWebhookForm.nameHint' | translate }}
            </div>
            }
            @if (formGroup.get('name').invalid && formGroup.get('name').touched) {
            <div class="invalid-feedback">
              {{ 'shared.settingsWebhookForm.nameRequired' | translate }}
            </div>
            }
          </div>
          <div class="col-12 mb-2">
            <label for="url" class="form-label">{{ 'shared.settingsWebhookForm.urlLabel' | translate }} <span class="text-info" style="cursor: pointer"
                (click)="toggleUrlTooltip()" [title]="'shared.settingsWebhookForm.urlInfoTitle' | translate">
                <i class="fas fa-question-circle"></i>
              </span></label>
            <input id="url" formControlName="url" class="form-control" placeholder="https://api.meusistema.com/webhook"
              [ngClass]="{ 'is-invalid': formGroup.get('url').invalid && formGroup.get('url').touched }" />
            @if (showUrlTooltip) {
            <div class="text-muted small mt-1">
              {{ 'shared.settingsWebhookForm.urlHint' | translate }}
            </div>
            }
            @if (formGroup.get('url').invalid && formGroup.get('url').touched) {
            <div class="invalid-feedback">
              {{ 'shared.settingsWebhookForm.urlRequired' | translate }}
            </div>
            }
          </div>
          <div class="col-12 mb-3">
            <label class="form-label">{{ 'shared.settingsWebhookForm.eventLabel' | translate }} <span class="text-info" style="cursor: pointer"
                (click)="toggleEventTooltip()" [title]="'shared.settingsWebhookForm.eventInfoTitle' | translate">
                <i class="fas fa-question-circle"></i>
              </span></label>
            <mat-select class="form-control" formControlName="events"
              [placeholder]="'shared.settingsWebhookForm.eventPlaceholder' | translate"
              [ngClass]="{ 'is-invalid': formGroup.get('events').invalid && formGroup.get('events').touched }" multiple>
              @if (showEventTooltip) {
              <div class="text-muted small mt-1 mb-2">
                {{ 'shared.settingsWebhookForm.eventHint' | translate }}
              </div>
              }
              <mat-option [value]="'ATTENDANCE_CREATE'">{{ 'shared.settingsWebhookForm.eventAttendanceCreate' | translate }}</mat-option>
              <mat-option [value]="'ATTENDANCE_CLOSE'">{{ 'shared.settingsWebhookForm.eventAttendanceClose' | translate }}</mat-option>
              <mat-option [value]="'ATTENDANCE_NEW_MESSAGE'">{{ 'shared.settingsWebhookForm.eventAttendanceNewMessage' | translate }}</mat-option>
              <mat-option [value]="'ATTENDANCE_REFERRAL_CREATE'">{{ 'shared.settingsWebhookForm.eventAttendanceReferralCreate' | translate }}</mat-option>
              <mat-option [value]="'ATTENDANCE_TRANSFER'">{{ 'shared.settingsWebhookForm.eventAttendanceTransfer' | translate }}</mat-option>
            </mat-select>
            <field-error-component [field]="'events'" [label]="'shared.settingsWebhookForm.eventsErrorLabel' | translate" [formGroup]="formGroup" />
          </div>



        </div>
      </form>
    </div>

    <div class="modal-footer">
      <div class="w-100 d-flex justify-content-between align-items-center">
        <a href="javascript:void(0);" class="text-info" (click)="toggleWebhookInfo()">
          <i class="fas fa-info-circle me-1"></i> {{ 'shared.settingsWebhookForm.whatIsWebhook' | translate }}
        </a>
        <div>
          <button type="button" class="btn btn-light me-2" (click)="close()">
            {{ 'shared.settingsWebhookForm.cancel' | translate }}
          </button>
          <button type="submit" class="btn btn-primary" [mat-dialog-close]="true" [disabled]="!formGroup.valid"
            (click)="onSubmit()">
            {{ 'shared.settingsWebhookForm.confirm' | translate }}
            @if (loading) {
            <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
            }
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

@if(showWebhookInfo) {
<div class="webhook-info-overlay" (click)="toggleWebhookInfo()">
  <div class="webhook-info-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="webhookInfoModalLabel">
          <i class="fas fa-info-circle text-info me-2"></i> {{ 'shared.settingsWebhookForm.whatIsWebhook' | translate }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="toggleWebhookInfo()"></button>
      </div>
      <div class="modal-body">
        <p>
          {{ 'shared.settingsWebhookForm.webhookInfoParagraph1' | translate }}
        </p>
        <p>
          {{ 'shared.settingsWebhookForm.webhookInfoParagraph2' | translate }}
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="toggleWebhookInfo()">{{ 'shared.settingsWebhookForm.understood' | translate }}</button>
      </div>
    </div>
  </div>
</div>
}